const map = {
	"./a11ycat/sagas.js": "./src/modules/a11ycat/sagas.js",
	"./api/sagas.js": "./src/modules/api/sagas.js",
	"./applications/sagas.js": "./src/modules/applications/sagas.js",
	"./authentication/sagas/index.js": "./src/modules/authentication/sagas/index.js",
	"./toast/sagas.js": "./src/modules/toast/sagas.js"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules sync recursive \\.\\/\\w+\\/sagas(.js%7C\\/index.js)";